"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultClient = exports.ApiError = void 0;
const form_data_1 = __importDefault(require("form-data"));
const content_disposition_1 = require("content-disposition");
const sessionCookieName_1 = __importDefault(require("./sessionCookieName"));
const js_cookie_1 = __importDefault(require("js-cookie"));
class ApiError extends Error {
    static rejectFromResponse(response) {
        return response.text().then(details => {
            const apiError = new ApiError();
            apiError.status = response.status;
            apiError.message = response.statusText;
            try {
                apiError.details = JSON.parse(details);
                // Extract the details if it's in a format we know about.
                if (apiError.details && apiError.details.errors) {
                    const error = apiError.details.errors[0];
                    if (error && error === Object(error)) {
                        if (error.name) {
                            apiError.name = error.name;
                        }
                        if (error.message) {
                            apiError.message = error.message;
                        }
                    }
                }
            }
            catch (e) {
                apiError.details = details;
            }
            throw apiError;
        });
    }
    static throwFromFetchFailure(fetchError) {
        const apiError = new ApiError();
        apiError.status = ApiClient.UNKNOWN_ERROR;
        if (fetchError instanceof TypeError && fetchError.message === 'Failed to fetch') {
            apiError.name = fetchError.name;
            apiError.message = 'Failed to connect to the server';
            apiError.details = {};
            apiError.details.errors = [{ message: apiError.message }];
        }
        else {
            apiError.details = fetchError;
        }
        throw apiError;
    }
}
exports.ApiError = ApiError;
function modifyOptions(options) {
    //add in an auth header with the cookie value if needed
    const headers = (options === null || options === void 0 ? void 0 : options.headers) ? options.headers : {};
    if (!headers['Authorization'] && js_cookie_1.default.get(sessionCookieName_1.default)) {
        headers['Authorization'] = `Bearer ${js_cookie_1.default.get(sessionCookieName_1.default)}`;
        options.headers = headers;
    }
    return options;
}
class ApiClient {
    constructor(service_hostname) {
        this.service_hostname = service_hostname;
    }
    httpRequest(path, options) {
        let url = null;
        if (this.service_hostname) {
            url = `${window.location.protocol}//${this.service_hostname}/${path.replace(/^\//, '')}`;
        }
        options = {
            method: 'GET',
            ...options,
        };
        options = modifyOptions(options);
        // fetch and resolve to the json (if success), or a useful error (if not)
        return fetch(url || path, options).then(response => {
            if (response.ok) {
                // if the response is successful but non-JSON, still return an empty object
                return response.json().catch(() => ({}));
            }
            return ApiError.rejectFromResponse(response);
        }, 
        // conn refused, other unhandled stuff, etc
        originalError => ApiError.throwFromFetchFailure(originalError));
    }
    httpGet(path, options) {
        options = {
            ...options,
            credentials: 'include',
        };
        return this.httpRequest(path, options);
    }
    httpPost(path, dataDictionary, options) {
        return this.httpUpdate('POST', path, dataDictionary, options);
    }
    httpPut(path, dataDictionary, options) {
        return this.httpUpdate('PUT', path, dataDictionary, options);
    }
    httpDelete(path, dataDictionary, options) {
        return this.httpUpdate('DELETE', path, dataDictionary, options);
    }
    httpUpdate(method, path, dataDictionary, options) {
        const extendedOptions = {
            ...options,
            method: method,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dataDictionary),
            credentials: 'include',
        };
        return this.httpRequest(path, extendedOptions);
    }
    multipartUpload(path, dataDictionary, options) {
        const form = new form_data_1.default();
        Object.keys(dataDictionary).forEach(key => {
            form.append(key, dataDictionary[key]);
        });
        const extendedOptions = {
            ...options,
            method: 'POST',
            body: form,
            credentials: 'include',
        };
        return this.httpRequest(path, extendedOptions);
    }
    download(path, options) {
        let url = null;
        if (this.service_hostname) {
            url = `${window.location.protocol}//${this.service_hostname}/${path.replace(/^\//, '')}`;
        }
        options = {
            method: 'GET',
            credentials: 'include',
            ...options,
        };
        options = modifyOptions(options);
        let filename;
        return fetch(url || path, options)
            .then((response) => {
            if (response.ok) {
                filename = content_disposition_1.parse(response.headers.get('content-disposition')).parameters.filename;
                return response.blob();
            }
            return ApiError.rejectFromResponse(response);
        }, 
        // conn refused, other unhandled stuff, etc
        originalError => ApiError.throwFromFetchFailure(originalError))
            .then(blob => {
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            return filename;
        });
    }
}
exports.default = ApiClient;
// unofficial, but commonly used for `Unknown Error`
ApiClient.UNKNOWN_ERROR = 520;
exports.DefaultClient = new ApiClient();
//# sourceMappingURL=ApiClient.js.map